import { Box, Editable, EditablePreview, EditableTextarea, Text, Textarea } from '@chakra-ui/react';
import React from 'react';
import { getToday } from '../../../handlers/helpers';
import { getJobInfo,freeFormEdit } from '../utils';

const PreviewBody = ({ props,  savedResume,  isDesktop }) => {
  const sectionName = 'parse-letter';

  const section = savedResume['parse-letter']['0'];
  const today = getToday();
  const jobInfo = getJobInfo(props);
  let city = jobInfo.city;
  const state = jobInfo.state;
  if ((typeof city !== 'undefined' && city !== '') &&( typeof state !== 'undefined' &&  state !== '' )) {
    city = city + ','
  }
  const paragraphs = section.PL6;
  return (
      <Box  className="mainBox contact"
            overflowY= 'auto'
          maxHeight= '500px'>
        <Box className='header' >
          <Text  >{today}</Text>
        <Text  >{section.PL1}</Text>
          <Box margin='2rem 0'>
            <Text >{jobInfo.companyName}</Text>
          <Text >{jobInfo.address}</Text>
            <Text >{city} {state} {jobInfo.zip}</Text>
          </Box>
        </Box>
        {Object.values(paragraphs).map((paragraph, index) => {
            return (
              <Box key={index} className='infoWrapper' width='90%'>

                <Editable className="editableTag" autoResize defaultValue={paragraph}>
                  <EditablePreview />
                  <EditableTextarea onBlur={(e) => freeFormEdit(e,props,index)}
                  />
                </Editable>
              </Box>
            );
        })}
      </Box>
    );
};
export default PreviewBody;
